import {
  SharedFileRequest,
  SharedFileRequestStatus
} from "@wingspanhq/wingspan-api-sdk";

import { selectorIsSharedFileNotNoneContext } from "./selectorIsSharedFileNotNoneContext";

export function selectorIsSharedFileReUploadFlow(
  sharedFile: SharedFileRequest | undefined
): boolean {
  return (
    selectorIsSharedFileNotNoneContext(sharedFile?.contextType) &&
    sharedFile?.status === SharedFileRequestStatus.PENDING_SUBMISSION
  );
}
